import { Link } from 'react-router';
import { Box, Container, Typography, Grid } from '@mui/material';

export function AboutSection() {
  return (
    <Box sx={{ bgcolor: 'background.paper', py: { xs: 8, md: 8 } }}>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={{ xs: 6, md: 8 }}
          alignItems="center"
        >
            {/* Foto */}
            <Grid size={{ xs: 12, md: 5 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Box
                  component="img"
                  src="/img/profil1.webp"
                  alt="Mgr. Hana Jarkovská"
                  loading="lazy"
                  sx={{
                    width: '100%',
                    maxWidth: 450,
                    height: 'auto',
                    borderRadius: '5%',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.02)',
                    },
                  }}
                />
              </Box>
            </Grid>

            {/* Text */}
            <Grid size={{ xs: 12, md: 7 }}>
              <Typography
                variant="h2"
                sx={{
                  mt: 6,
                  mb: 4,
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  fontWeight: 500,
                }}
              >
                O mně
              </Typography>

              {/* Citát */}
              <Box
                sx={{
                  p: 3,
                  mb: 4,
                  bgcolor: '#f9e8ce',
                  borderLeft: '4px solid',
                  borderColor: 'primary.dark',
                  borderRadius: 1,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Lora, Georgia, serif',
                    fontStyle: 'italic',
                    fontSize: '1.15rem',
                    lineHeight: 1.8,
                    color: 'text.primary',
                  }}
                >
                  „Respektuji lidi v jejich plné rozmanitosti a oceňuji každý jejich osobitý přístup k
                  životu."
                </Typography>
              </Box>

              <Typography
                paragraph
                sx={{
                  mb: 3,
                  lineHeight: 1.8,
                  fontSize: '1.05rem',
                  textAlign: 'justify'
                }}
              >
                Zaměřuji se na psychoterapii a etopedii v práci s dětmi, dospívajícími, dospělými i rodinami.
                Obě oblasti se vzájemně doplňují – psychoterapie se zaměřuje na emoce, vnitřní konflikty,
                vztahy a osobní témata, zatímco etopedie se věnuje chování a jeho souvislostem v prostředí,
                například v práci, škole, rodině nebo v každodenních situacích.
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'flex-start', gap: 1, mb: 4 }}>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    paragraph
                    sx={{
                      mb: 3,
                      lineHeight: 1.8,
                      fontSize: '1.05rem',
                      textAlign: 'justify'
                    }}
                  >
                    Pracuji integrativně – napříč různými psychoterapeutickými směry – a volím metody podle toho,
                    co klient právě potřebuje a co daná situace vyžaduje, s ohledem na jeho zkušenosti a cíle.
                  </Typography>
                  <Typography
                    paragraph
                    sx={{
                      mb: 3,
                      lineHeight: 1.8,
                      fontSize: '1.05rem',
                      textAlign: 'justify'
                    }}
                  >
                    V rámci spolupráce dbám na to, aby byl proces srozumitelný a zároveň vytvořit prostor pro hledání vlastních řešení.
                  </Typography>

                  <Typography
                    component={Link}
                    to="/o-mne"
                    sx={{
                      display: 'inline-block',
                      fontSize: '1.05rem',
                      fontWeight: 600,
                      color: 'primary.dark',
                      textDecoration: 'none',
                      borderBottom: '2px solid',
                      borderColor: 'primary.dark',
                      pb: 0.5,
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        color: 'text.primary',
                        borderColor: 'text.primary',
                        transform: 'translateX(4px)',
                      },
                    }}
                  >
                    Více o mně →
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Box
                    component="img"
                    src="/img/CAP_odznak_M_ve_vycviku_web.png"
                    alt="Psychoterapeut ve výcviku - Česká asociace pro psychoterapii"
                    loading="lazy"
                    sx={{
                      width: { xs: 290, sm: 290 },
                      height: 'auto',
                      filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.1))',
                    }}
                  />
                </Box>
              </Box>
            </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
